import { createFileRoute } from "@tanstack/react-router";
import { GovernanceTeamRolesContent } from "@/components/GovernanceTeamRolesContent";

export const Route = createFileRoute("/governance")({
  head: () => ({
    meta: [
      { title: "Governance & Team Roles | Recovery Trauma™" },
      {
        name: "description",
        content:
          "Leadership structure, qualifications, responsibilities, boundaries, and accountability framework for Recovery Trauma™ — supporting compliance, safeguarding, governance, and audit readiness.",
      },
      { property: "og:title", content: "Governance & Team Roles | Recovery Trauma™" },
      {
        property: "og:description",
        content:
          "Leadership, qualifications, responsibilities, boundaries, and accountability across Recovery Trauma™.",
      },
      { property: "og:url", content: "https://recoverytrauma.com/governance" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://recoverytrauma.com/governance" }],
  }),
  component: GovernancePage,
});

function GovernancePage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-16">
      <GovernanceTeamRolesContent variant="public" />
    </div>
  );
}
